import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info';

@Injectable({ providedIn: 'root' })
export class ToastService {
  message = signal<string | null>(null);
  type = signal<ToastType>('info');

  private timeoutId?: number;

  private _show(msg: string, t: ToastType, duration = 4000) {
    // Clear previous toast
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.message.set(msg);
    this.type.set(t);

    this.timeoutId = window.setTimeout(() => {
      this.message.set(null);
    }, duration);
  }

  success(msg: string, duration = 3000) {
    this._show(msg, 'success', duration);
  }

  error(msg: string, duration = 5000) {
    this._show(msg, 'error', duration);
  }

  info(msg: string, duration = 4000) {
    this._show(msg, 'info', duration);
  }

  showError(msg: string) {
    this.error(msg);
  }
}